import {
  Button,
  FormControl,
  FormItem,
  FormLabel,
  Input,
} from "@gearbox-protocol/deploy-tools-ui";
import { type FC, useCallback } from "react";
import type { ControllerRenderProps } from "react-hook-form";

import type { ForkSchema } from "../schema";

const DEPLOY_V3 = "@gearbox-protocol/deploy-v3";
const TAG_NEXT = "@next";
const TAG_MAIN = "@main";
const TAG_CHANNEL: Record<string, string> = {
  [TAG_NEXT]: "@next",
  [TAG_MAIN]: "",
};

interface ScriptNpxLiteProps {
  field: ControllerRenderProps<ForkSchema, `scripts.${number}.npx`>;
}

const ScriptNpxLite: FC<ScriptNpxLiteProps> = props => {
  const { field } = props;
  const { value, onChange } = field;
  const isDeployV3 = !!value?.toLowerCase().startsWith(DEPLOY_V3);
  const isMain = field.value?.toLowerCase() === DEPLOY_V3;
  const isNext =
    field.value?.toLowerCase() === `${DEPLOY_V3}${TAG_CHANNEL[TAG_NEXT]}`;

  const toggleTag = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const tag = e.currentTarget.getAttribute("data-tag");
      const channel = TAG_CHANNEL[tag ?? ""] ?? "";
      onChange(`${DEPLOY_V3}${channel}`);
    },
    [onChange],
  );

  return (
    <FormItem className="flex flex-row items-center">
      <FormLabel className="w-24">NPM Package</FormLabel>
      <FormControl className="mr-2">
        <Input
          value={field.value}
          contentEditable={false}
          tabIndex={-1}
          className="h-8 cursor-none pointer-events-none w-[300px]"
          readOnly
        />
      </FormControl>
      {isDeployV3 && (
        <>
          {!isMain && (
            <Button
              type="button"
              variant="link"
              size="icon"
              data-tag={TAG_MAIN}
              onClick={toggleTag}
              className="font-mono text-xs"
            >
              @main
            </Button>
          )}
          {!isNext && (
            <Button
              type="button"
              variant="link"
              size="icon"
              data-tag={TAG_NEXT}
              onClick={toggleTag}
              className="font-mono text-xs"
            >
              @next
            </Button>
          )}
        </>
      )}
    </FormItem>
  );
};

export default ScriptNpxLite;
